'use client';

import Box from '@enlighten/design-system/dist/Box';
import Button from '@enlighten/design-system/dist/Button';
import Dialog from '@enlighten/design-system/dist/Dialog';
import IconButton from '@enlighten/design-system/dist/IconButton';
import Close from '@mui/icons-material/Close';
import { useState } from 'react';

import IconArrowRight from '@/assets/images/pages/grid-vpp/section3-arrow-right.svg';
import ImgMap1 from '@/assets/images/pages/grid-vpp/section3-map-1.png';
import ImgMap2 from '@/assets/images/pages/grid-vpp/section3-map-2.png';

import type { Section3CardProps } from './Section3Card';
import Section3Card from './Section3Card';

const COMMON = <b>(1·2차 공통)</b>;

const CARDS: Section3CardProps[] = [
	{
		title: '전라남도 - 11개 선로',
		map: ImgMap2,
		tags: [
			{ region: '곡성군', details: '풍산' },
			{ region: '나주시', details: <>운곡{COMMON}</> },
			{ region: '무안군', details: '운남, 서해, 석용' },
			{ region: '보성군', details: <>춘양{COMMON}</> },
			{ region: '신안군', details: <>안하{COMMON}, 남촌, 비도</> },
			{ region: '화순군', details: <>이양{COMMON}</> },
			{ region: '해남군', details: <>문내{COMMON}</> },
		],
	},
	{
		title: '전라북도 - 29개 선로',
		map: ImgMap1,
		tags: [
			{ region: '고창군', details: '용수, 아산, 공단, 흥덕, 무장' },
			{ region: '김제시', details: '성덕, 학동, 대청, 명천, 백구, 부교, 부량, 용지' },
			{ region: '남원시', details: '강석, 아영, 보절' },
			{ region: '무주군', details: '부남' },
			{ region: '익산시', details: '용동, 함라, 시내' },
			{ region: '장수군', details: '오성, 원촌' },
			{ region: '정읍시', details: '소성, 오주, 신정, 매계, 옹동, 승방, 산내' },
		],
	},
];

const Section3LinesDialog = () => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<Button
				variant="outlined"
				onClick={() => setOpen(true)}
				endIcon={<IconArrowRight width={16} height={16} />}
				sx={{
					bgcolor: '#FFFFFF',
					// fontWeight: 700,
					color: '#1D1E1F',
					'& .MuiButton-endIcon': { marginLeft: '6px', marginRight: 0 },
				}}
				data-analytics="section3_lines_button"
			>
				1차 공고 대상 보기
			</Button>
			<Dialog
				open={open}
				onClose={() => setOpen(false)}
				fullWidth
				maxWidth="lg"
				sx={{ zIndex: 99999 }}
				slotProps={{ paper: { sx: { bgcolor: '#F1F8FF', borderRadius: '20px', padding: { xs: '50px 16px 16px', md: '60px 30px 30px' } } } }}
			>
				<IconButton aria-label="닫기" onClick={() => setOpen(false)} sx={{ position: 'absolute', top: '10px', right: '10px' }}>
					<Close />
				</IconButton>
				<Box
					sx={{
						display: 'grid',
						gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
						gap: { xs: '16px', md: '24px' },
					}}
				>
					{CARDS.map((card) => (
						<Section3Card key={card.title} {...card} />
					))}
				</Box>
			</Dialog>
		</>
	);
};

export default Section3LinesDialog;
